import type { WorldLocation } from "./types";

export const WORLD_MAP: WorldLocation[] = [
  {
    id: "sunset-harbor",
    name: "Sunset Harbor",
    page: "dashboards",
    settlement: "town",
    emoji: "🏛️",
    mapX: 50,
    mapY: 45,
    description: "A bustling harbor where explorers pin dashboards and compare signals.",
    questHint: "Start your journey by checking your command board.",
  },
  {
    id: "query-square",
    name: "Query Square",
    page: "discover",
    settlement: "town",
    emoji: "🔬",
    mapX: 75,
    mapY: 20,
    description: "A hilltop lab where ES|QL scrolls reveal hidden patterns.",
    questHint: "Experiment with a query and refine it before heading out.",
  },
  {
    id: "signal-mill",
    name: "Signal Mill",
    page: "logs",
    settlement: "village",
    emoji: "📚",
    mapX: 80,
    mapY: 55,
    description: "A riverside mill where log streams are filtered and sorted.",
    questHint: "Tune filters to isolate the story inside your logs.",
  },
  {
    id: "watchtower-ridge",
    name: "Watchtower Ridge",
    page: "explore",
    settlement: "outpost",
    emoji: "🔭",
    mapX: 20,
    mapY: 25,
    description: "A high ridge for scanning metric storms and spotting drift.",
    questHint: "Adjust views and watch changing trends over time.",
  },
  {
    id: "trace-grove",
    name: "Trace Grove",
    page: "traces",
    settlement: "village",
    emoji: "🌲",
    mapX: 30,
    mapY: 70,
    description: "A grove where trace routes form bright paths through the woods.",
    questHint: "Follow one request path to find service bottlenecks.",
    unlockAfterQuestIds: ["scout-the-frontier"],
  },
  {
    id: "guild-hall",
    name: "Guild Hall",
    page: "services",
    settlement: "town",
    emoji: "🏪",
    mapX: 60,
    mapY: 75,
    description: "A meeting hall where service owners coordinate reliability work.",
    questHint: "Visit after your first expedition to unlock guild rewards.",
    unlockAfterQuestIds: ["scout-the-frontier", "stabilize-the-signal-mill"],
  },
  {
    id: "cloud-castle",
    name: "Cloud Castle",
    page: "kubernetes",
    settlement: "outpost",
    emoji: "☁️",
    mapX: 15,
    mapY: 10,
    description: "A floating fortress where pods and containers swirl in the mist.",
  },
  {
    id: "server-farm",
    name: "Server Farm",
    page: "hosts",
    settlement: "village",
    emoji: "🖥️",
    mapX: 85,
    mapY: 35,
    description: "A sprawling farm where host machines hum and blink.",
  },
  {
    id: "terminal-tower",
    name: "Terminal Tower",
    page: "console",
    settlement: "outpost",
    emoji: "💻",
    mapX: 25,
    mapY: 50,
    description: "A dark tower where raw API commands echo through the halls.",
  },
  {
    id: "overview-spire",
    name: "Overview Spire",
    page: "clusterOverview",
    settlement: "town",
    emoji: "🗼",
    mapX: 50,
    mapY: 15,
    description: "A tall spire that surveys the entire cluster landscape.",
  },
  {
    id: "gear-shop",
    name: "Gear Shop",
    page: "settings",
    settlement: "village",
    emoji: "⚙️",
    mapX: 70,
    mapY: 85,
    description: "A workshop where LLM keys and preferences are forged.",
  },
];

export const WORLD_MAP_BY_PAGE = new Map(WORLD_MAP.map((location) => [location.page, location]));
